import { PostingDatePicker } from "../../components/PostingDatePicker";
import { GroupedAmountInput } from "../../components/GroupedAmountInput";
import { RfqDesiredMilestonesEditor, RfqDesiredPricesEditor } from "../../components/RfqDesiredTerms";
import type { PostFlowModel } from "./createPostFlowReview";

export function PostTermsStep({ model }: { model: PostFlowModel }) {
  const {
    type, translate, translatedAmountLabel, map, step, form, setDeadlineInputValid,
    deadlineDraft, setDeadlineDraft, rfqItems, rfqDesiredMilestones, setRfqDesiredMilestones,
    isServicesRfq, set, setItem, draft, itemPricingField
  } = model;
  return step === 4 && (
            <div className="space-y-4">
              <h3 className={`font-bold text-navy ${type === "item" ? "text-xl leading-tight" : ""}`}>{translate("posting.pricingTerms")}</h3>
              {type === "company" ? (
                <p className="text-sm text-mut">No pricing needed for a company page — continue.</p>
              ) : type === "item" ? itemPricingField  : type === "rfq" ? (
                <>
                  <p className="text-sm text-mut">{isServicesRfq ? "Add your desired payment milestones. Providers will propose the final price and payment terms in Messages." : "Set a desired price for any line item. Suppliers can quote the quantities they can supply."}</p>
                  {isServicesRfq
                    ? <RfqDesiredMilestonesEditor stages={rfqDesiredMilestones} onChange={setRfqDesiredMilestones} />
                    : <RfqDesiredPricesEditor lines={rfqItems.map((row, index) => ({ ...row, index })).filter(row => row.name.trim())} onChange={(index, price) => setItem(index, "desiredPrice", price)} />}
                  <div>
                    <label className="label" htmlFor="rfq-deadline">Quote deadline</label>
                    <PostingDatePicker id="rfq-deadline" calendarLabel="Choose quote deadline" value={form.deadline} draft={deadlineDraft} onDraftChange={setDeadlineDraft} onChange={(value) => set("deadline", value)} onValidityChange={setDeadlineInputValid} />
                  </div>
                </>
              ) : type === "resume" ? (
                <>
                  <div className="grid sm:grid-cols-2 gap-3">
                    <div>
                      <label className="label">{translate("posting.rate", "Rate")} / Pricing (PHP)</label>
                      <GroupedAmountInput id="posting-rate" aria-label="Rate / Pricing (PHP)" value={form.rateAmount} onChange={value => set("rateAmount", value)} placeholder="e.g. 600" />
                    </div>
                    <div>
                      <label className="label">Per</label>
                      <select className="field" value={form.ratePeriod} onChange={(e) => set("ratePeriod", e.target.value)}>
                        <option value="hour">Hour</option>
                        <option value="day">Day</option>
                        <option value="week">Week</option>
                        <option value="month">Month</option>
                        <option value="project">Project</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="label">Engagement term</label>
                    <select className="field" value={form.term} onChange={(e) => set("term", e.target.value)}>
                      <option value="Negotiable">Negotiable</option>
                      <option value="Full-time">Full-time</option>
                      <option value="Part-time">Part-time</option>
                      <option value="Contract">Contract</option>
                      <option value="Per project">Per project</option>
                    </select>
                  </div>
                  <div><label className="label">Years of experience</label><input className="field" inputMode="numeric" value={form.amount} onChange={(e) => set("amount", e.target.value)} placeholder="e.g. 8" /></div>
                  <p className="text-xs text-mut">Your rate and engagement term show on your résumé so clients know what to expect before they reach out.</p>
                </>
              ) : type === "project" ? (
                <>
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="label" htmlFor="project-budget">{translate("cards.privateEstimate", "Your estimate (private)")} (PHP) <span className="font-normal text-mut">({translate("posting.optionalLabel")})</span></label>
                      <GroupedAmountInput id="project-budget" value={form.amount} onChange={value => set("amount", value)} placeholder="e.g. 2,500,000" />
                      <p className="mt-1 text-xs text-mut">Private reminder for you. This estimate is not shown to bidders.</p>
                    </div>
                    <div>
                      <label className="label" htmlFor="project-deadline">Bidding deadline</label>
                      <PostingDatePicker id="project-deadline" calendarLabel="Choose bidding deadline" value={form.deadline} draft={deadlineDraft} onDraftChange={setDeadlineDraft} onChange={(value) => set("deadline", value)} onValidityChange={setDeadlineInputValid} />
                    </div>
                  </div>
                  <p className="rounded-lg border border-line bg-navy-50/60 p-3 text-xs leading-relaxed text-mut">You can sort received bids by lowest price when reviewing them. There is no award method to choose when posting.</p>
                </>
              ) : (
                <>
                  <div className={type === "job" ? "grid gap-3 sm:grid-cols-2" : ""}>
                    <div><label className="label" htmlFor="posting-amount">{translatedAmountLabel || "Amount"}</label><GroupedAmountInput id="posting-amount" value={form.amount} onChange={value => set("amount", value)} placeholder={type === "job" ? "e.g. 25,000" : "e.g. 50,000"} /></div>
                    {type === "job" && <div>
                      <label className="label" htmlFor="posting-deadline">Deadline</label>
                      <PostingDatePicker id="posting-deadline" wheel={type === "job"} calendarLabel="Choose deadline" value={form.deadline} draft={deadlineDraft} onDraftChange={setDeadlineDraft} onChange={(value) => set("deadline", value)} onValidityChange={setDeadlineInputValid} />
                    </div>}
                  </div>
                </>
              )}
            </div>
          );
}
